import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAdvertisementhome } from "../../features/advertisementhomeSlice";
import { useDispatch, useSelector } from "react-redux";

const Addsec = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { advertisementhomedata, status, error } = useSelector(
    (state) => state.advertisementhome
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAdvertisementhome());
    }
  }, [dispatch, status]);

  const Categorypage = (item) => {
    if (item.select_type == 1) {
      if (item.category_slug && item.subcategory_slug && item.subchildcategory_slug) {
        navigate(`/${item.category_slug}/${item.subcategory_slug}/${item.subchildcategory_slug}`);
      } else if (item.category_slug && item.subcategory_slug) {
        navigate(`/${item.category_slug}/${item.subcategory_slug}`);
      } else if (item.category_slug) {
        navigate(`/${item.category_slug}`);
      }
    } else if (item.select_type == 2) {
      if (item.product_slug) {
        navigate(`/product-details/${item.product_slug}`);
      }
    } else if (item.select_type == 3) {
      if (item.classification_slug) {
        navigate(`/classification_list/${item.classification_slug}`);
      }
    }
  };

  if (!advertisementhomedata || !advertisementhomedata.advertisement_img) return null;

  return (
    <div
      className="addsec-bg"
      onClick={() => Categorypage(advertisementhomedata)}
      style={{
        backgroundImage: `url(${advertisementhomedata.advertisement_img})`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6"></div>
        </div>
      </div>
    </div>
  );
};

export default Addsec;
